import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { LineChart, Loader2, Send, Play } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

const month = (m) => (m ? new Date(`${m}-15`).toLocaleDateString("en-AU", { month: "long", year: "numeric" }) : "");

export const MarketSnapshot = () => {
  const [s, setS] = useState(null);
  const load = useCallback(() => api.get("/market/status").then((r) => setS(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { if (!s?.running) return undefined; const t = setInterval(load, 8000); return () => clearInterval(t); }, [s?.running, load]);
  if (!s) return null;
  const run = async () => {
    if (!window.confirm(`Take this month's market snapshot now and email it to ${s.subscribers} subscribers plus you?`)) return;
    try { await api.post("/market/run"); toast.success("Taking the market snapshot"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const test = async () => { try { const r = await api.post("/market/test"); toast.success(`Test sent to ${r.data.sent_to}`); } catch (e) { toast.error(errMsg(e)); } };
  const failed = (s.results || []).filter((r) => !r.ok);
  const doneThisMonth = s.last_month === s.this_month;
  return (
    <div className="border border-[#E2D9CC] bg-[#FAF7F2] p-5 mb-6 flex flex-wrap items-center gap-4" data-testid="market-snapshot">
      <LineChart className="w-5 h-5 text-[#C59B27]" strokeWidth={1.5} />
      <div className="mr-auto">
        <p className="eyebrow mb-1">Monthly market snapshot</p>
        {s.running
          ? <p className="text-sm" data-testid="market-snapshot-progress">Checking prices… {(s.results || []).length} towns done</p>
          : <p className="text-sm text-[#6B5B4E]" data-testid="market-snapshot-status">
              {s.last_month ? `${month(s.last_month)} sent to ${s.sent_to ?? 0} subscribers and you (${s.towns} towns). ` : "Not run yet. "}
              Runs automatically on the 1st of each month and moves calculator home prices with the market.
            </p>}
        {!s.running && failed.length > 0 && <p className="text-xs text-red-700 mt-1" data-testid="market-snapshot-failed">No data this month for: {failed.map((f) => f.town).join(", ")}</p>}
      </div>
      <div className="flex gap-2 ml-auto">
        {s.last_month && <Button variant="outline" onClick={test} disabled={s.running} className="rounded-none" data-testid="market-snapshot-test"><Send className="w-4 h-4 mr-2" />Send me a test</Button>}
        <Button onClick={run} disabled={s.running || doneThisMonth} className="rounded-none" data-testid="market-snapshot-run">
          {s.running ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Play className="w-4 h-4 mr-2" />}{doneThisMonth ? "Sent this month" : "Run now"}
        </Button>
      </div>
    </div>
  );
};
